/* eslint-disable */
export default {
  methods: {
    handleContentClick: function (evt) {
      let target = this.isDescendantOfLink(evt.target) ? this.isDescendantOfLink(evt.target) : evt.target;

      if (target.tagName === "A") {
        evt.preventDefault();

        const href = target.href;
        const anchorPattern = /#([a-zA-Z0-9_-]+)$/; // match # followed by any characters and numbers

        // Check if the link is an anchor
        if (href.match(anchorPattern)) {
          this.scrollToAnchor(href);
        } else if (window.cordova) {
          this.openUrlInApp(href);
        } else {
          this.openUrlOnWebsite(href);
        }
      }
    },
    openUrlOnWebsite(link) {
      const linkUrl = new URL(link);

      if (linkUrl.host === process.env.VUE_APP_WEBSITE_HOST || linkUrl.hostname === "localhost") {
        this.openInternalPage(linkUrl);
      } else {
        window.open(link, "_blank");
      }
    },
    openUrlInApp(link) {
      if (link.indexOf("mailto:") > -1) {
        const emailOptions = {};
        let email = link.replace("mailto:", "");

        if (link.indexOf("?") > -1) {
          email = link.split("?")[0].split(":")[1];
          const params = new URLSearchParams(link.split("?")[1]);

          if (params.get("subject")) {
            emailOptions.subject = params.get("subject");
          }

          if (params.get("body")) {
            emailOptions.body = params.get("body");
          }
        }

        emailOptions.to = email;

        window.cordova.plugins.email.open(emailOptions);
      } else if (link.indexOf("tel:") > -1) {
        const number = link.replace("tel:", "");

        window.cordova.plugins.phonedialer.dial(number);
      } else if (link.indexOf("sms:") > -1) {
        const number = link.replace("sms:", "");
        const message = "";
        const options = {
          replaceLineBreaks: false,
          android: {
            intent: "INTENT",
          },
        };

        sms.send(number, message, options);
      } else if (
        window.device.platform === "Android" &&
        (link.endsWith(".pdf") ||
          link.endsWith(".docx") ||
          link.endsWith(".doc") ||
          link.endsWith(".xls") ||
          link.endsWith(".xlsx") ||
          link.endsWith(".ppt") ||
          link.endsWith(".pptx"))
      ) {
        window.cordova.InAppBrowser.open(link, "_system");
      } else {
        const linkUrl = new URL(link);

        if (linkUrl.host === process.env.VUE_APP_WEBSITE_HOST || linkUrl.hostname === "localhost") {
          // need to know ios host name
          this.openInternalPage(linkUrl);
        } else {
          let linkPath = link.indexOf("http") > -1 ? link : "http://" + link;

          let browserConfig =
            "location=no,footer=yes,footercolor=#CC000000,closebuttoncaption=Done,closebuttoncolor=#FFFFFF";

          if (window.device.platform === "iOS") {
            browserConfig = "toolbarposition=top,closebuttoncolor=#000000,toolbarcolor=#cccccc,location=no";
          }

          window.cordova.InAppBrowser.open(linkPath, "_blank", browserConfig);
        }
      }
    },
    openInternalPage(linkUrl) {
      let linkPath = "";

      if (linkUrl.hash) {
        linkPath = linkUrl.hash.replace("#", "");
      } else if (linkUrl.pathname !== undefined && linkUrl.pathname !== "/") {
        linkPath = linkUrl.pathname;
      }

      this.$router.push({ path: linkPath });
    },
    scrollToAnchor(href) {
      // Anchor link, scroll to it
      const anchorIdentifier = href.substring(href.indexOf("#") + 1);
      let anchorElement = document.getElementById(anchorIdentifier);

      // If the anchor doesn't exist, try to find it by name
      if (!anchorElement) {
        anchorElement = document.getElementsByName(anchorId);
      }

      if (anchorElement) {
        anchorElement.scrollIntoView({ behavior: "smooth" });
      }
    },
    isDescendantOfLink(child) {
      var node = child.parentNode;

      while (node != null) {
        if (node.tagName == "A") {
          return node;
        }
        node = node.parentNode;
      }

      return false;
    },
  },
};
/* eslint-enable */
